// extracted by mini-css-extract-plugin
export default {"wrapper":"RoutesListItem_wrapper__ZxMKp","link":"RoutesListItem_link__rlyUO"};